module.exports = __webpack_public_path__ + "static/media/header.a8847bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/transplant/header.png
// module id = 374
// module chunks = 1